import PropTypes from 'prop-types';
import React from 'react';

class GridAction extends React.PureComponent {
  onClick = () => {
    const { onClick, item } = this.props;

    onClick(item);
  };

  onKeyUp = (event) => {
    if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
      this.onClick();
    }
  };

  render() {
    const { children } = this.props;

    return (
      <span
        onClick={this.onClick}
        onKeyUp={this.onKeyUp}
        className="grid__action"
        role="button"
        tabIndex="0"
      >
        {children}
      </span>
    );
  }
}

GridAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default GridAction;
